import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, useScroll, useSpring } from "framer-motion";
const navItems = [
  {
    name: "Home",
    href: "#home",
  },
  {
    name: "Skills",
    href: "#skills",
  },
  {
    name: "Services",
    href: "#services"
  },
  {
    name: "Projects",
    href: "#projects ",
  },
  {
    name: "Contact",
    href: "#contact",
  },
];
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });
  useEffect(() => {
    const handleScroll = () => {
      const sections = navItems.map((item) => item.name.toLowerCase());
      const currentSection = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (currentSection) {
        setActiveSection(currentSection);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav className="fixed w-full z-50">
      {/* Progress Bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-[10px] bg-gradient-to-r from-blue-500 to-purple-300 transform origin-left"
        style={{
          scaleX,
        }}
      />

      <div className="w-full bg-gray-900/75 backdrop-blur-sm border-b border-gray-800/50">
        <div className="max-w-6xl mx-auto flex justify-between items-center py-4 px-4">
          <motion.a
            href="#home"
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            className="text-white font-bold text-xl relative group"
          >
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
              Kenan Smajić
            </span>
            <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-to-r from-blue-400 to-purple-400 group-hover:w-full transition-all duration-300" />
          </motion.a>
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <motion.a
                key={item.name}
                href={item.href}
                whileHover={{
                  y: -2,
                }}
                className={`relative px-2 py-1 text-sm font-medium transition-colors ${
                  activeSection === item.name.toLowerCase()
                    ? "text-white"
                    : "text-gray-300 hover:text-white"
                }`}
              >
                {item.name}
                {activeSection === item.name.toLowerCase() && (
                  <motion.span
                    layoutId="activeSection"
                    className="absolute inset-0 -z-10 rounded-md bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-gray-700/50"
                  />
                )}
              </motion.a>
            ))}
          </div>
          <button
            className="md:hidden text-white p-2 rounded-lg hover:bg-gray-800/50 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            initial={{
              opacity: 0,
              height: 0,
            }}
            animate={{
              opacity: 1,
              height: "auto",
            }}
            exit={{
              opacity: 0,
              height: 0,
            }}
            transition={{
              duration: 0.3,
            }}
            className="md:hidden border-t border-gray-800/50 bg-gray-900/95 backdrop-blur-md"
          >
            {navItems.map((item) => (
              <motion.a
                key={item.name}
                href={item.href}
                initial={{
                  x: -20,
                  opacity: 0,
                }}
                animate={{
                  x: 0,
                  opacity: 1,
                }}
                whileHover={{
                  x: 4,
                }}
                className={`block px-4 py-3 text-sm transition-colors ${
                  activeSection === item.name.toLowerCase()
                    ? "text-white bg-gradient-to-r from-blue-500/10 to-purple-500/10"
                    : "text-gray-300 hover:text-white"
                }`}
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </motion.a>
            ))}
          </motion.div>
        )}
      </div>
    </nav>
  );
};
